export const VERIFY_NEVER = 1;
export const VERIFY_RUNNING = 2;
export const VERIFY_SUCCESS = 3;
export const VERIFY_FAILED = 4;
export const VERIFY_CANCEL = 5;
export const WAITING = 6;
export const TEMP = 0;
export const ERROR = -99; // Only for front-end Error check